export default "__VITE_ASSET__CNg4o5ya__"